const WixConfig = {
    backendApiBaseUrl: 'https://stageapi.wix.exportfeed.com',
    settingsPageId: 'ebd2fecf-4a85-47dc-b640-9fbabbbec131',
    subscriptionPageId: '68e02dc2-575d-47b8-a838-b0f92c8459e6'
}

export default WixConfig;